import { Button, Modal, ModalProps } from "antd-mobile";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { ReactNode } from "react";

export interface IConfirmModal extends ModalProps {
  onConfirmClick: () => void;
  onCancelClick: () => void;
  loading?: boolean;
  subTitle?: ReactNode;
  yesButtonText?: string;
  cancelButtonText?: string;
}

export const ConfirmModal: FC<IConfirmModal> = ({
  onConfirmClick,
  onCancelClick,
  loading = false,
  subTitle = "",
  yesButtonText = "Yes",
  cancelButtonText = "No",
  ...props
}) => {
  return (
    <Modal
      {...props}
      className={styles.modalCon}
      style={{ zIndex: 2000 }}
      getContainer={document.body}
      content={
        <div className={classNames(styles.content, "mt-2")}>
          <p id="sub-title" className={styles.subTitle}>
            {subTitle}
          </p>
          <div
            className="d-flex justify-content-center gap-2"
            style={{ marginBottom: "16px" }}
          >
            <Button
              fill="solid"
              color="primary"
              loading={loading}
              onClick={() => onConfirmClick()}
              data-test-id="confirm-modal-yes-btn"
              style={{ minWidth: "100px" }}
            >
              {yesButtonText}
            </Button>
            <Button
              data-test-id="confirm-modal-cancel-btn"
              onClick={() => onCancelClick()}
              disabled={loading}
              style={{ minWidth: "100px" }}
            >
              {cancelButtonText}
            </Button>
          </div>
        </div>
      }
    />
  );
};
